"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillTextBox = void 0;
const measure_text_1 = require("./measure-text");
const fillTextBox = ({ maxBoxWidth, maxLines, }) => {
    const lines = new Array(maxLines).fill(0).map(() => []);
    return {
        add: ({ text, fontFamily, fontWeight, fontSize, letterSpacing, fontVariantNumeric, validateFontIsLoaded, textTransform, additionalStyles, }) => {
            const lastLineIndex = lines.reduceRight((acc, curr, index) => {
                if (acc === -1 && curr.length > 0) {
                    return index;
                }
                return acc;
            }, -1);
            const currentlyAt = lastLineIndex === -1 ? 0 : lastLineIndex;
            const lineToUse = lines[currentlyAt];
            const lineWithWord = [
                ...lineToUse,
                {
                    text,
                    fontFamily,
                    fontWeight,
                    fontSize,
                    letterSpacing,
                    fontVariantNumeric,
                    validateFontIsLoaded,
                    textTransform,
                    additionalStyles,
                },
            ];
            const widths = lineWithWord.map((w) => (0, measure_text_1.measureText)(w).width);
            const lineWidthWithWordAdded = widths.reduce((a, b) => a + b, 0);
            if (Math.ceil(lineWidthWithWordAdded) < maxBoxWidth) {
                lines[currentlyAt].push({
                    text: lines[currentlyAt].length === 0 ? text.trimStart() : text,
                    fontFamily,
                    fontWeight,
                    fontSize,
                    letterSpacing,
                    textTransform,
                    fontVariantNumeric,
                });
                return { exceedsBox: false, newLine: false };
            }
            if (currentlyAt === maxLines - 1) {
                return { exceedsBox: true, newLine: false };
            }
            lines[currentlyAt + 1] = [
                {
                    text: text.trimStart(),
                    fontFamily,
                    fontWeight,
                    fontSize,
                    letterSpacing,
                    textTransform,
                    fontVariantNumeric,
                },
            ];
            return { exceedsBox: false, newLine: true };
        },
    };
};
exports.fillTextBox = fillTextBox;
